export const MESSAGES = {
  APPROVE: {
    SUCCESS: {
      variant: "default",
      description: "Termo aprovado com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao aprovar termo.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  REJECT: {
    SUCCESS: {
      variant: "default",
      description: "Termo rejeitado com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao rejeitar termo.",
      duration: 5000,
      closeOnClick: true,
    },
  },

  APPROVE_TERM: {
    SUCCESS: { description: "Termo aprovado com sucesso", variant: "default" },
    ERROR: { description: "Erro ao aprovar termo", variant: "destructive" },
  },
  REJECT_TERM: {
    SUCCESS: { description: "Termo rejeitado com sucesso", variant: "default" },
    ERROR: { description: "Erro ao rejeitar termo", variant: "destructive" },
  },
  REJECT_SIGNATURE: {
    SUCCESS: { description: "Assinatura rejeitada com sucesso", variant: "default" },
    ERROR: { description: "Erro ao rejeitar assinatura", variant: "destructive" },
  },
  COMMENT_REQUIRED: { description: "Informe o motivo da recusa", variant: "destructive" },
  USER_ACCESS_CREATED: { variant: "success", description: "Usuário criado com sucesso." },
  FILE_DOWNLOAD: {
    SUCCESS: { variant: "default", description: "Arquivo baixado com sucesso", duration: 5000 },
    ERROR: { description: "Erro ao tentar baixar o arquivo. Tente novamente.", variant: "destructive", duration: 5000 },
  },
  REPLACE_SIGNED_TERM: {
    SUCCESS: { description: "Termo substituído e aprovado com sucesso", variant: "default" },
    ERROR: "Erro ao substituir o termo assinado",
  },
} as const;

export const REPLACE_SIGNED_TERM_LABELS = {
  TITLE: "Substituir Arquivo e Aprovar",
  HINT:
    "Use apenas quando o termo assinado correto chegou por outro meio. O novo arquivo passa a ser o termo válido e a solicitação é aprovada.",
  FILE: "Novo termo assinado",
  REASON: "Motivo da substituição",
  REASON_PLACEHOLDER: "Ex.: Regional enviou o termo assinado por e-mail em 20/09",
  CONFIRM_WITHOUT_USER: "Substituir e Aprovar sem Criar Usuário",
  CONFIRM_WITH_USER: "Substituir e Aprovar e Criar Usuário",
  BACK: "Voltar",
  SUBMITTING: "Substituindo...",
} as const;

export const TERM_HISTORY_COMMENTS = {
  APPROVED_WITH_USER: "Termo aprovado e usuário criado.",
  APPROVED_WITHOUT_USER: "Termo aprovado sem criação de usuário.",
} as const;

export const buildApprovalHistoryComment = (base: string, userComment: string): string =>
  userComment.trim() ? `${base} ${userComment}` : base;
